
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.75 24C2.902 24 0 22.388 0 20.25v-6c0-2.138 2.902-3.75 6.75-3.75s6.75 1.612 6.75 3.75v6c0 2.138-2.902 3.75-6.75 3.75zM1.5 20.25c0 1.062 2.245 2.25 5.25 2.25S12 21.312 12 20.25v-.598C10.75 20.506 8.858 21 6.75 21s-4-.494-5.25-1.348v.598zm0-3c0 1.062 2.245 2.25 5.25 2.25S12 18.312 12 17.25v-.598C10.75 17.506 8.858 18 6.75 18s-4-.494-5.25-1.348v.598zM6.75 12c-3.005 0-5.25 1.188-5.25 2.25s2.245 2.25 5.25 2.25S12 15.312 12 14.25 9.755 12 6.75 12z"}}),_c('path',{attrs:{"d":"M15.75 16.5a.75.75 0 010-1.5h6a.75.75 0 00.75-.75v-12a.75.75 0 00-.75-.75H2.25a.75.75 0 00-.75.75v7.507a.75.75 0 01-1.5 0V2.25A2.252 2.252 0 012.25 0h19.5A2.252 2.252 0 0124 2.25v12a2.252 2.252 0 01-2.25 2.25h-6z"}}),_c('path',{attrs:{"d":"M13.979 11.255a.748.748 0 01-.749-.799.743.743 0 01.254-.515 2.248 2.248 0 00.107-3.282A2.235 2.235 0 0012 6c-.601 0-1.166.234-1.591.659-.425.425-.659.99-.659 1.591a.75.75 0 01-1.5 0c0-1.002.39-1.943 1.099-2.652A3.725 3.725 0 0112 4.5c1.002 0 1.944.39 2.652 1.099a3.75 3.75 0 01-.178 5.47.75.75 0 01-.495.186z"}}),_c('circle',{attrs:{"cx":"4.5","cy":"4.5","r":"1.125"}}),_c('circle',{attrs:{"cx":"19.5","cy":"12","r":"1.125"}})])
          )
        }
      }
    